export const promoCode = {
	promo_code: {
		wrapper: 'col-md-12',
		component: 'text-input',
		label: 'Got a promo code? Enter it here',
		required: false,
	},
};

export const firstTime = {
	first_time: {
		wrapper: 'col-md-12',
		component: 'radio-input-group',
		label: 'Is this your first-time attending {show}?',
		newEntryReset: true,
		options: {
			Yes: '1',
			No: '0',
		},
	},
};

export const terms = {
	terms: {
		wrapper: 'col-md-12',
		component: 'check-input',
		defaultValue: false,
		uncheckedValue: false,
		checkedValue: true,
		label: 'Terms & Conditions and Privacy Policy',
		slot:
			'I agree to the <a href="{termsUrl}" target="_blank">Terms & Conditions</a> and <a href="https://www.xpo.co.nz/privacy-policy/" target="_blank">Privacy Policy</a>',
		newEntryReset: true,
	},
};

// !! kiwisaverConsent and cactusConsent both use the same key 'privacy3' - only use one
export const kiwisaverConsent = {
	privacy3: {
		wrapper: 'col-md-12',
		component: 'check-input',
		defaultValue: false,
		uncheckedValue: false,
		checkedValue: true,
		label: 'Generate KiwiSaver Competition',
		slot:
			'Yes, I want to hear from a Generate KiwiSaver adviser and be in to win a 2 night stay at Te Aari Links?<br><small>*By selecting yes, you consent to being contacted by a Generate KiwiSaver adviser.</small>',
		newEntryReset: true,
		required: false,
	},
};

// !! kiwisaverConsent and cactusConsent both use the same key 'privacy3' - only use one
export const cactusConsent = {
	privacy3: {
		wrapper: 'col-md-12',
		component: 'check-input',
		defaultValue: false,
		uncheckedValue: false,
		checkedValue: true,
		label: 'Cactus Competition',
		slot:
			'Do you wish to enter the registration door prize draw to win a $2000 BBQ prize pack and receive further information from Cactus Insurance (prize sponsor)?',
		newEntryReset: true,
		required: false,
	},
};

export default { ...promoCode, ...firstTime, ...terms, ...kiwisaverConsent, ...cactusConsent };
